import React from 'react'
import { LazyLoadImage } from 'react-lazy-load-image-component';
import { useParams } from 'react-router-dom';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import Navbar from '../../components/Navbar';
import SmallFooter from '../../components/SmallFooter';

const ProductDetails = () => {
    const { productId } = useParams();
    const [product, setProduct] = React.useState({});
    const [isLoading, setIsLoading] = React.useState(true);

    const notify = (text) => toast(text, {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
    });

    const addToCart = () => {
        if (localStorage.getItem('token') === null) {
            window.location.href = '/login'
        }

        try {
            fetch(process.env.REACT_APP_SERVER_URL + '/cart/addtocart', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': 'Bearer ' + localStorage.getItem('token')
                },
                body: JSON.stringify({
                    productId: product._id
                })
            })
                .then(res => res.json())
                .then(data => {
                    notify(data)
                }
                ).catch(err => {
                    notify(err.message)
                })
        } catch (err) {
            console.log(err)
        }
    }

    React.useEffect(() => {
        try {
            fetch(process.env.REACT_APP_SERVER_URL + '/shop/getProduct', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({
                    productId: productId
                })
            })
                .then(res => res.json())
                .then(data => {
                    console.log(data)
                    if (data.success) {
                        setProduct(data.product);
                        setIsLoading(false);
                    }
                    
                })
                .catch(err => {
                    console.log(err);
                })
        } catch (error) {
            console.log(error);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    return (
        <div className='mx-auto '>
            <div>
                <Navbar />
            </div>
            <div>
                <ToastContainer className='mt-20' />
            </div>
            {isLoading ?
                <div className="flex justify-center items-center w-[1180px]  mx-auto min-h-screen ">
                    <div className="animate-spin rounded-full h-32 w-32 border-t-2 border-b-2 border-green-600"></div>
                </div>
                :
                <div className=' mt-10 mx-2 '>
                    <div className='flex flex-col md:flex-row justify-center items-center gap-4 w-full'>
                        <div className='flex flex-col justify-center items-center  md:w-1/2 '>
                        
                            <LazyLoadImage
                            alt="ecommerce"
                            className="object-cover object-center md:scale-90" 
                            effect="blur"
                          
                            src={product.imgUrl} // use normal <img> attributes as props
                        />
                        </div>
                        <div className='flex flex-col justify-center items-start md:w-1/2'>
                            <h2 className="text-2xl font-bold dark:text-white text-gray-900 sm:pr-12">{product.name}</h2>

                            <section aria-labelledby="information-heading" className="mt-2">
                                <h3 id="information-heading" className="sr-only">
                                    Product information
                                </h3>

                                <p className="text-xl dark:text-white text-gray-900">₹ {product.cost_per_unit}</p>

                                {/* Reviews */}

                            </section>

                            <div class="flex items-center mt-4">
                                <svg aria-hidden="true" class="w-5 h-5 text-yellow-400" fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><title>Rating star</title><path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z"></path></svg>
                                <p class="ml-2 text-sm font-bold text-gray-900 dark:text-white">
                                    {
                                        product.ratingCount === 0 ? '0' : product.totalRating / product.ratingCount

                                    }
                                </p>
                                <span class="w-1 h-1 mx-1.5 bg-gray-500 rounded-full dark:bg-gray-400"></span>
                                <p class="text-sm font-medium text-gray-900 underline hover:no-underline dark:text-white">{product.ratingCount} reviews</p>
                            </div>

                            <section aria-labelledby="options-heading" className="mt-10">
                                <h3 id="options-heading" className="sr-only">
                                    Product options
                                </h3>

                                <div>
                                    <h2 className="text-3xl dark:text-white font-bold tracking-tight text-gray-900 sm:text-2xl">Description</h2>
                                    <p className="mt-4 text-gray-500 dark:text-white">
                                        {product.description}
                                    </p>

                                    <dl className="mt-16 grid grid-cols-1 gap-x-6 gap-y-10 sm:grid-cols-2 sm:gap-y-16 lg:gap-x-8">
                                        {product.features?.map((prod) => (
                                            <div key={prod.name} className="border-t border-gray-200 pt-4">
                                                <dt className="font-medium dark:text-white text-gray-900">{prod.name}</dt>
                                                <dd className="mt-2 text-sm dark:text-white text-gray-500">{prod.description}</dd>
                                            </div>
                                        ))}
                                    </dl>
                                    {product.quantity > 0 ?

                                        <button
                                            onClick={() => {
                                                addToCart();
                                            }}
                                            className="mt-6 flex w-full items-center justify-center rounded-md border border-transparent bg-green-600 py-2 px-4 text-base font-medium text-white hover:bg-green-700 focus:outline-none focus:ring-2 focus:ring-green-500 focus:ring-offset-2"
                                        >
                                            Add to bag
                                        </button>
                                        :
                                        <button
                                            onClick={() => {
                                                notify('Product is out of stock')
                                            }}
                                            className="mt-6 flex w-full items-center justify-center rounded-md border border-transparent bg-red-600 py-2 px-4 text-base font-medium text-white hover:bg-red-700 focus:outline-none focus:ring-2 focus:ring-red-500 focus:ring-offset-2"
                                        >
                                            Out of Stock
                                        </button>
                                    }

                                </div>

                            </section>
                        </div>
                    </div>
                </div>}
            <div className=' w-full'>
                <SmallFooter />
            </div>

        </div>
    )
}

export default ProductDetails